export default "__VITE_ASSET__7HEIugB3__"